import React from 'react';
import {Stack, Typography} from '@mui/material';

import {ChannelRegionProps} from './types';

export function ChannelRegion({label, children}: ChannelRegionProps) {
	return (
		<Stack gap={1}>
			<Typography variant="body1" color="primary">
				{label}
			</Typography>
			{children}
		</Stack>
	);
}
